import React, { useEffect, useRef } from 'react';

interface HamburgerProps {
    setOpen: React.Dispatch<React.SetStateAction<boolean>>; // Function to toggle menu state
    isOpen: boolean; // Boolean to track if the menu is open
}

const Hamburger: React.FC<HamburgerProps> = ({ setOpen, isOpen }) => {
    const hamburgerRef = useRef<HTMLDivElement | null>(null);

    useEffect(() => {
        const handleClick = () => {
            setOpen(!isOpen);
        };

        const hamburgerElement = hamburgerRef.current;

        if (hamburgerElement) {
            hamburgerElement.addEventListener('click', handleClick);
        }

        return () => {
            if (hamburgerElement) {
                hamburgerElement.removeEventListener('click', handleClick);
            }
        };
    }, [isOpen, setOpen]);

    return (
        <div
            className={`hamburger-menu relative z-10 flex w-auto cursor-pointer flex-col items-start justify-center gap-2 transition-all duration-300 xl:hidden`}
            id='hamburger-menu'
            ref={hamburgerRef} // Directly toggle the boolean value
        >
            <div
                className={`menu-bar1 h-[2px] w-6 bg-text transition-all duration-500 dark:bg-white ${isOpen ? 'translate-x-[-0.6rem] translate-y-[0.4rem] -rotate-45' : ''}`}
            ></div>
            <div
                className={`menu-bar2 ml-auto h-[2px] w-4 bg-text transition-all duration-500 dark:bg-white ${isOpen ? 'opacity-0' : ''}`}
            ></div>
            <div
                className={`menu-bar3 h-[2px] w-6 bg-text transition-all duration-500 dark:bg-white ${isOpen ? 'translate-x-[-0.6rem] translate-y-[-0.9rem] rotate-45' : ''}`}
            ></div>
        </div>
    );
};

export default Hamburger;
